<script setup lang="ts">

import {useAssetStore} from "@/stores/assetStore.ts";
import {useShipDesignCreationStore} from "@/stores/shipDesignCreationStore.ts";
import ShipDesignComponent from "@/components/Interface/Modal/Modals/ModalCreateShipDesign/ShipDesignComponent.vue";
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Stores / models
 */
const assetStore = useAssetStore()
const shipDesignCreationStore = useShipDesignCreationStore()

/**
 * Props
 */
const props = defineProps({
  componentCode: {
    type: String,
    required: true
  }
});

/**
 * Variables
 */
const component = assetStore.findShipComponentByCode(props.componentCode)

</script>

<template>
  <ShipDesignComponent :component="component">
    <ActionButton
        @click="shipDesignCreationStore.addComponent(component,true);"
        :full-width="true">{{ t('common.actions.add') }}</ActionButton>
  </ShipDesignComponent>
</template>

<style scoped lang="scss">

</style>